import { SVGProps, Ref, forwardRef } from 'react';

export const ImageFilledSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 24C2 4.75 4.75 2 24 2s22 2.75 22 22c0 3.684-.1 6.764-.399 9.336l-10.659-8.803-7.305 5.741-10.935-8.579L2.4 33.352C2.101 30.777 2 27.692 2 24m1.153 13.383C5.204 44.67 10.61 46 24 46s18.796-1.33 20.847-8.618l-9.96-8.226-7.248 5.696-10.894-8.547zM27.5 15c0-1.75.875-3.5 3.5-3.5s3.5 1.75 3.5 3.5-.875 3.5-3.5 3.5-3.5-1.75-3.5-3.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageFilledSize48Glyph.displayName = 'ImageFilledSize48Glyph';
